import { View, Text } from "react-native";
import { ChevronDownIcon, ChevronUpIcon } from "ui/gluestack/icon";
import { AccordionIcon } from "ui/gluestack/accordion";
import { AssessmentStatus } from "../atoms/AssessmentStatus";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { useAssessmentState } from "../hooks/useAssessmentState";

interface Props {
  assessment: SubmittedFormModel;
  isExpanded?: boolean;
  versioned?: boolean;
}

export function AssessmentHeader({ assessment, isExpanded, versioned }: Props) {
  const { createdByText, signedOffText, barthelScore } = useAssessmentState({
    form: assessment,
  });
  const showChevrons = isExpanded !== undefined;
  return (
    <>
      <View className="items-start gap-1">
        {!versioned ? (
          <Text className="text-base font-semibold">
            {assessment.form.name}
          </Text>
        ) : null}
        <View className="flex-row">
          <Text className="text-sm font-normal">{createdByText}</Text>
        </View>
        {signedOffText ? (
          <View className="flex-row">
            <Text className="text-sm font-normal">{signedOffText}</Text>
          </View>
        ) : null}
      </View>
      <View className="flex-row gap-x-10">
        {barthelScore ? (
          <Text className="text-sm font-semibold text-primary-500">
            Score: {barthelScore}
          </Text>
        ) : null}

        {!versioned ? <AssessmentStatus status={assessment.status} /> : null}

        {showChevrons ? (
          <AccordionIcon as={isExpanded ? ChevronUpIcon : ChevronDownIcon} />
        ) : null}
      </View>
    </>
  );
}
